import styled from '@emotion/styled';
import { themeFont } from '../../lib/themeFont';
import { PropsWithChildren } from 'react';
import { ThemeProps } from '@emotion/react';

const Note = styled('h4')`
  line-height: 1;
  margin: 12px auto;
  margin-bottom: 36px;
  text-align: center;
  max-width: 900px;
  ${themeFont('s6')}
`;

const StandaloneNote = styled('h4')`
  ${themeFont('s6')}

  background-color: ${(props: ThemeProps): string =>
    props.theme.fonts.s6.color};
  border-radius: 0.25rem;
  color: ${(props: ThemeProps): string => props.theme.colors.background};
  line-height: 2;
  padding: 1.25rem;
  margin-bottom: 2em;
  text-align: center;

  max-width: 700px;
  margin: 0 32px;
`;

interface RegistryNoteProps {
  standalone?: boolean | undefined;
  show?: boolean;
  htmlContent?: { __html: string } | undefined;
}

export const RegistryNote = (props: PropsWithChildren<RegistryNoteProps>) => {
  if (!props.show) {
    return null;
  }

  let NoteComponent = Note;

  if (props.standalone) {
    NoteComponent = StandaloneNote;
  }

  if (props.children) {
    return <NoteComponent>{props.children}</NoteComponent>;
  }

  return <NoteComponent dangerouslySetInnerHTML={props.htmlContent} />;
};
